//= include libs/jquery.min.js
//= include libs/jquery-ui.min.js

//= include plugins/nouislider.min.js
//= include plugins/popper.min.js
//= include plugins/tippy-bundle.js
//= include plugins/fancybox.js
//= include plugins/fancybox-autoplay.js
//= include plugins/fancybox-settouch.js

//= include parts/core.js
//= include parts/autocomplete-popup.js
//= include parts/ui.js
//= include parts/password-toggle.js

$(document).ready(function() {
	let $body = $('body');
	let $window = $(window);
	function createCookie(name, value, days = 0, hours = 0) {
		let expires = "";
		if (days > 0 || hours > 0) {
			const date = new Date();
			date.setTime(date.getTime() + ((days * 24 + hours) * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}
	/* Popup banner - small */
	let popupBanner = $('#popup');
    if (popupBanner.length) {
		$('.popup__close', popupBanner).on('click', function() {
			createCookie('hideRightBanner', 1, 0, 2);
			popupBanner.remove();
		});
		if(!popupBanner.hasClass('popup--dontClose')){
			$(popupBanner).on('click', function() {
				createCookie('hideRightBanner', 1, 0, 2);
				popupBanner.remove();
			});
		}
	}

	let homepagePopupBanner = $('#popup-large');
	if (homepagePopupBanner.length) {
		$('.popup__close', homepagePopupBanner).on('click', function() {
			createCookie('hideHomepagePopup', 1, 0, 2);
			homepagePopupBanner.remove();
		});

	}

	/* Category: Filter & Sort */
	function showFilter() {
		$('.row__col--sidebar').show();

		setTimeout(function(){
			$('.filter').addClass('filter--is-active');
		},100);

		$('.overlay').fadeIn(300);
	}

	function hideFilter() {
		$('.filter').removeClass('filter--is-active');

		setTimeout(function(){
			$('.row__col--sidebar').hide();
		},300);

		$('.overlay').fadeOut(300);
	}

	function showSort() {
		$('.category__sort').addClass('category__sort--is-active');
		$('.overlay').fadeIn(300);
	}

	function hideSort() {
		$('.category__sort').removeClass('category__sort--is-active');
		$('.overlay').fadeOut(300);
	}

	let triggerFilter = $('#trigger-filter'),
		triggerSort = $('#trigger-sort');

	if (triggerFilter.length && triggerSort.length) {

		triggerFilter.on('click', function(e){
			e.preventDefault();
			showFilter();
		});

		triggerSort.on('click', function(e){
			e.preventDefault();
			showSort();
		});

		$('.filter__close, .overlay').on('click', function() {
			hideFilter();
		});

		$('.category__sort-close, .overlay').on('click', function() {
			hideSort();
		});
	}

	let collapsibleHeader = $('.collapsible-header');
	if (collapsibleHeader.length) {
		collapsibleHeader.on('click', function() {
			$(this).toggleClass('collapsible-header--hidden');
			$(this).next('.collapsible-content').toggle();
		});
	}


	/* Count */

	let inputCounts =  $('.input--count');
	if (inputCounts.length) {

		inputCounts.on('input.changed', function (e, target) {
			localStorage.setItem('scrollPosition', window.scrollY);
			let form = target.closest('form.eshopCartForm');
			if (form.length) {
				$(form).trigger('submit');
			}
		});

		$('input', inputCounts).on('change', function() {
			inputCounts.trigger('input.changed', $(this));
		});

		$('.input__descent', inputCounts).on('click', function() {
			let target = $(this);
			if (parseInt(target.siblings('input').val()) > 1) {
				let i = parseInt(target.siblings('input').val()) - 1;
				target.siblings('input').val(i);
				inputCounts.trigger('input.changed', target);
			}
		});

		$('.input__ascent', inputCounts).on('click', function() {
			let target = $(this);
			let i = parseInt(target.siblings('input').val()) + 1;
			target.siblings('input').val(i);
			inputCounts.trigger('input.changed', target);
		});
	}

	/* Prislusenstvo */

	let noAccessory =  $('.donWantAccessory');
	if (noAccessory.length) {
		noAccessory.on('input.changed', function () {
			let target = $(this);
			let form = target.closest('form.eshopCartForm');
			if (form.length) {
				$(form).trigger('submit');
			}
		});
	}

	/* Product */

	if ($('#product-tabs').length) {

		let tabClass = 'tabs__item',
			tabContentClass = 'product-detail__info';

		$('.' + tabClass).on('click', function() {
			$('.' + tabClass).removeClass(tabClass + '--active');
			$(this).addClass(tabClass + '--active');

			$('.' + tabContentClass).removeClass(tabContentClass + '--active');
			$('.' + tabContentClass + '[data-content=' + $(this).data('tabs') + ']').addClass(tabContentClass + '--active');
		});

		/* Reset tabs to 'desc' */

		const goToDesc = $('#goToDesc');

		goToDesc.on('click', function() {
			$('.' + tabClass).removeClass(tabClass + '--active');
			$('.' + tabClass + '[data-tabs="desc"]').addClass(tabClass + '--active');

			$('.' + tabContentClass).removeClass(tabContentClass + '--active');
			$('.' + tabContentClass + '[data-content="desc"]').addClass(tabContentClass + '--active');
		});
	}

	/* Homepage */

	if ($('#homepage-tabs').length) {

		let tabClass = 'tabs__item',
			tabClassAnimation = 'tabs__item--animation',
			tabContentClass = 'selected-products__list';

		$('.' + tabClass).on('click', function() {
			$('.' + tabClass).removeClass(tabClass + '--active');
			$(this).addClass(tabClass + '--active');

			$('.' + tabContentClass).removeClass(tabContentClass + '--active');
			$('.' + tabContentClass + '[data-content=' + $(this).data('tabs') + ']').addClass(tabContentClass + '--active');
		});

	}

	/* Checkout */

    if ($('.select-delivery').length) {

    	let item = 'select-delivery',
    		radio = $('.select-delivery__radio');

		radio.on('change', function() {
			if (radio.is(':checked')) {
				$('.' + item).removeClass(item + '--active');
				$(this).parent().parent().addClass(item + '--active');
	    	}
    	});
    }

    if ($('.select-payment').length) {

    	let item = 'select-payment',
    		radio = $('.select-payment__radio');

		if (radio.is(':checked')) {
			$(':checked', radio).parent().parent().addClass(item + '--active');
    	}

		radio.on('change', function() {
			if (radio.is(':checked')) {
				$('.' + item).removeClass(item + '--active');
				$(this).parent().parent().addClass(item + '--active');
	    	}
    	});
    }

    /* Scroll to top */

	let scrollToTop = document.getElementById("scroll-to-top");

	window.onscroll = function() {
		scrollFunction();
	};

	function scrollFunction() {
	  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	    scrollToTop.classList.remove("scroll-to-top--hidden");
	  } else {
	    scrollToTop.classList.add("scroll-to-top--hidden");
	  }
	}

	scrollToTop.addEventListener('click', function() {
		document.body.scrollTop = 0; // For Safari
  		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	});

    /* Mobile nav */

    $('.sidebar-nav__level-1 > li.sidebar-nav__item > span').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();

		$(this).next('.sidebar-nav__level-2').show();
		$('.sidebar-nav__wrapper')
			.removeClass('sidebar-nav__wrapper--level-1')
			.addClass('sidebar-nav__wrapper--level-2');
        $('.sidebar-nav').scrollTop(0);
        setTimeout(function() { checkSidebarScrollArrows(getActiveLevel()); }, 50);
    });

    $('.sidebar-nav__level-2 > li.sidebar-nav__item > span').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		e.stopImmediatePropagation();

		$(this).next('.sidebar-nav__level-3').show();
		$('.sidebar-nav__wrapper')
			.removeClass('sidebar-nav__wrapper--level-2')
			.addClass('sidebar-nav__wrapper--level-3');
        $('.sidebar-nav').scrollTop(0);
        setTimeout(function() { checkSidebarScrollArrows(getActiveLevel()); }, 50);
    });

    $('.sidebar-nav__back-to-1').on('click', function() {
    	$(this).parent().fadeOut(300);
    	$('.sidebar-nav__wrapper')
			.removeClass('sidebar-nav__wrapper--level-2')
			.addClass('sidebar-nav__wrapper--level-1');
        $('.sidebar-nav').scrollTop(0);
        setTimeout(function() { checkSidebarScrollArrows(getActiveLevel()); }, 50);
    });

    $('.sidebar-nav__back-to-2').on('click', function() {
    	$(this).parent().fadeOut(300);
    	$('.sidebar-nav__wrapper')
			.removeClass('sidebar-nav__wrapper--level-3')
			.addClass('sidebar-nav__wrapper--level-2');
        $('.sidebar-nav').scrollTop(0);
        setTimeout(function() { checkSidebarScrollArrows(getActiveLevel()); }, 50);
    });

    function checkSidebarScrollArrows($level) {
        var $nav = $('.sidebar-nav');
        var contentHeight = $level.outerHeight();
        var clientHeight = $nav[0].clientHeight;
        var scrollTop = $nav.scrollTop();
        var $arrowUp = $level.find('.sidebar-nav__scroll-arrow--up');
        var $arrowDown = $level.find('.sidebar-nav__scroll-arrow--down');
        if (contentHeight > clientHeight) {
            $arrowUp.css('display', scrollTop <= 1 ? 'none' : 'flex');
            $arrowDown.css('display', scrollTop + clientHeight >= contentHeight - 1 ? 'none' : 'flex');
        } else {
            $arrowUp.hide();
            $arrowDown.hide();
        }
    }

    function getActiveLevel() {
        var $wrapper = $('.sidebar-nav__wrapper');
        if ($wrapper.hasClass('sidebar-nav__wrapper--level-3')) {
            return $('.sidebar-nav__level-3:visible').first();
        } else if ($wrapper.hasClass('sidebar-nav__wrapper--level-2')) {
            return $('.sidebar-nav__level-2:visible').first();
        }
        return $('.sidebar-nav__level-1').first();
    }

    $('.sidebar-nav').on('scroll', function() { checkSidebarScrollArrows(getActiveLevel()); });

	$('.header__mobile-nav').on('click', function(){
    	$('.sidebar-nav').addClass('sidebar-nav--is-active');
    	$('.overlay').fadeIn(300);
    	$('body').css('overflow', 'hidden');
        setTimeout(function() { checkSidebarScrollArrows(getActiveLevel()); }, 350);
    });

    $('.sidebar-nav__close, .overlay').on('click', function(){
    	$('.sidebar-nav').removeClass('sidebar-nav--is-active');
    	$('.overlay').fadeOut(300);
    	$('body').css('overflow', 'auto');
    });

    /* Footer nav */

    $(window).resize(function() {
		if (window.innerWidth > 960) {
    		$('.footer__nav-item > span').next('ul').show();
    	} else if (window.innerWidth <= 960) {
    		$('.footer__nav-item > span').next('ul').removeAttr("style");
    	}

	});

    $('.footer__nav-item > span').on('click', function() {
    	if (window.innerWidth <= 960) {
    		$(this).next('ul').fadeToggle();
    	}
    });

	/* Variants */
	const variantItems = document.getElementsByClassName('variants__item');
	if (variantItems.length) {
		for (let i = 0; i < variantItems.length; i++) {
			const imageUrl = variantItems[i].getAttribute('data-image'),
				  image = `<img src="${imageUrl}" class="variants__preview" />`,
				  title = variantItems[i].getAttribute('data-value'),
				  tooltip = `${image} <br /> <span class="variants__preview-label">${title}</span>`;

			tippy(variantItems[i], {
				content: tooltip,
				allowHTML: true,
				theme: 'thumbs',
			});
		}

		const variantItem = $('.variants__item');
		variantItem.on('click', function(){
			let variant = $(this);
			variant.addClass('variants__item--active');
			variant.siblings('.variants__item').removeClass('variants__item--active');
			variant.closest('.variants__list').find('input').val(variant.data('value'));
		});
	}

	let processing = $('#processing');
	if (processing.length) {
		$body.on('click', 'a[data-processing="1"], button[data-processing="1"]', function () {
			processing.show();
		}).on('submit', 'form[data-processing="1"]', function () {
			processing.show();
		});
	}

	// ajaxove pridanie polozky do kosika
	let isSubmitted = false;
	$body.on('submit', 'form.addToCart', function () {
		let form = $(this);
		if (!isSubmitted) {
			isSubmitted = true;
			form.addToCart({
				complete : function(){
					isSubmitted = false;
				},
				success : function(){
					let popupOrder = $('#popupOrder');
					if (popupOrder.length) {
						popupOrder.find('.close').trigger('click');
					}
				}
			});
		}
		return false;
	});

	let tooltipDelivery = $('#tooltip-delivery');
	if (tooltipDelivery.length) {
		tippy('#' + tooltipDelivery.attr('id'), {
			content: tooltipDelivery.data('tooltip'),
			allowHTML: true,
			theme: 'light',
		});
	}
	let tooltipOrderOnly = $('#tooltip-orderOnly');
	if (tooltipOrderOnly.length) {
		tippy('#' + tooltipOrderOnly.attr('id'), {
			content: tooltipOrderOnly.data('tooltip'),
			allowHTML: true,
			theme: 'light',
		});
	}
	let tooltipCartPdf = $('#tooltip-cart-pdf');
	if (tooltipCartPdf.length) {
		tippy('#' + tooltipCartPdf.attr('id'), {
			content: tooltipCartPdf.data('tooltip'),
			allowHTML: true,
			theme: 'light',
		});
	}
	let tooltipMontageSummary = $('#tooltip-montage-summary');
	if (tooltipMontageSummary.length) {
		tippy('#' + tooltipMontageSummary.attr('id'), {
			content: tooltipMontageSummary.data('tooltip'),
			allowHTML: true,
			theme: 'light',
		});
	}
	// info bubliny (napr. kroky v kategorii) - data-tooltip na elemente s triedou js-tippy
	if ($('.js-tippy').length) {
		tippy('.js-tippy', {
			content: function (reference) {
				return $(reference).data('tooltip');
			},
			allowHTML: true,
			theme: 'light',
		});
	}

	let tooltipMontageDelivery = $('#tooltip-montage-delivery');
	if (tooltipMontageDelivery.length) {
		tippy('#' + tooltipMontageDelivery.attr('id'), {
			content: tooltipMontageDelivery.data('tooltip'),
			allowHTML: true,
			theme: 'light',
		});
	}

	// Fixed header

	let header = $('#header');

	function fixedHeader() {
	  if ($('body, html').scrollTop() > 1) {
	    header.addClass("header--fixed");
	    $('body').css("padding-top", header.outerHeight());
	  } else {
	  	header.removeClass("header--fixed");
	  	$('body').removeAttr('style');
	  }
	}

	$(window).scroll(function(){
		fixedHeader();
	});


	// Scroll to product description offset

	let productDescription = $('#productDescription');

	if (productDescription.length) {
		productDescription.css({
			position: 'relative',
			visibility: 'hidden',
			top: (-1 * $('#header').outerHeight() - 48) + 'px',
		});
	}

	//= include parts/homepage.js
	//= include parts/catalog.js
	//= include parts/product.js
	//= include parts/faq.js
});
